import { axiosGet, axiosPost } from "./axiosFunctions";
import { getAuthState } from "../../assets/scripts/login-util";

const getCalendarUrl         = '/api/doctor/calendar/getCalendar';
const postCalendarUrl        = '/api/doctor/calendar/postCalendar';
const deleteCalendarUrl      = '/api/doctor/calendar/deleteCalendar';

export const getCalendar = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getCalendarUrl, { headers: { auth_token: `bearer ${token}` }} );
    return response;
}

export const postCalendar = async (calendar) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postCalendarUrl,
        { calendar },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const deleteCalendar = async (calendarId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(   
        deleteCalendarUrl,        
        { headers: { auth_token: `bearer ${token}`},  params: { calendarId }} 
    );
    return response;
};